module.exports = __webpack_public_path__ + "media/images/favicon/favicon-152-df1ec5dc64bc32d07b56fb72e9d7c0bc.png";